import { Accordion, Stack } from "@introist/react-foundation/v2";
import { AgentTypeEditorProps } from "../editors";

export const HRHelpdeskAgentEditor = (props: AgentTypeEditorProps) => {
  return (
    <Stack vertical>
      <Accordion
        title="Triage"
        description="When the agent should respond"
        defaultOpen={false}
        toggleOpenOnHeaderClick
        compact
      ></Accordion>
      <Accordion
        title="Answer"
        description="How the agent should respond"
        defaultOpen={false}
        toggleOpenOnHeaderClick
        compact
      ></Accordion>
      <Accordion
        title="Approval"
        description="When to escalate to a human"
        defaultOpen={false}
        toggleOpenOnHeaderClick
        compact
      ></Accordion>
    </Stack>
  );
};
